import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Promocode from './components/promocode';
import { FetchLiveCapacity } from '../../actions/capacity';
import {  SetProcessing } from '../../actions/currentBooking';
import { upgradesName, upgradesPrice } from '../../helpers/upgradesHelper';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(AdvancedFormat);


class BasketSummary extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      tripPrice:0,
      tripDiscount:0,
      tripTotal:0,
      adultPrice:0,
      adultNumber:0,
      discountPercent:0,
      discountPercentText:0,
      upgradePrice:0
    }

    this.onContinueClick = this.onContinueClick.bind(this);
  }


  componentDidUpdate(prevProps, prevState){

    //check upgrade price
    if(prevProps.upgrades !== this.props.upgrades){     
      const tripPrice = this.state.adultPrice * this.state.adultNumber;
      const upgradePrice = upgradesPrice(this.props.upgrades) * this.state.adultNumber;
      this.setState({
        tripPrice: tripPrice,
        tripDiscount: tripPrice * this.state.discountPercent/100,
        tripTotal:tripPrice - (tripPrice * this.state.discountPercent/100) + upgradePrice,
        upgradePrice:upgradePrice
      });
    }


    //check if calender prices avaiable and save
    if(prevProps.prices !== this.props.prices){
      this.setState({adultPrice: this.props.prices['price_adult'] }, () => {
          const tripPrice = this.state.adultPrice * this.state.adultNumber;
          const upgradePrice = upgradesPrice(this.props.upgrades) * this.state.adultNumber;
          this.setState({
            tripPrice: tripPrice,
            tripDiscount: tripPrice * this.state.discountPercent/100,
            tripTotal: tripPrice - (tripPrice * this.state.discountPercent/100) + upgradePrice
          });
      });
    }


    //check passengers numbers
    if(prevProps.passengers !== this.props.passengers){

      let adultNum = 0;

      for(let i = 0; i < this.props.passengers.length; i++){
        if(this.props.passengers[i].age_category === 'Adult'){
          adultNum++;
        }
      }
      this.setState({ adultNumber:adultNum}, () => {
        const tripPrice = this.state.adultPrice * this.state.adultNumber;
        const upgradePrice = upgradesPrice(this.props.upgrades) * this.state.adultNumber;
        this.setState({
          tripPrice: tripPrice,
          tripDiscount: tripPrice * this.state.discountPercent/100,
          tripTotal:tripPrice - (tripPrice * this.state.discountPercent/100) + upgradePrice
        });
      });
    }

    //check discounts
    if(prevProps.discount !== this.props.discount){

      //calculate discount
      if(Object.keys(this.props.discount.data).length && this.props.discount.data.bookings[0].client_bookings.length !== 0){

        this.setState({
          discountPercentText:Math.round(this.props.discount.data.bookings[0].client_bookings[0].discount_percentage),
          discountPercent:this.props.discount.data.bookings[0].client_bookings[0].discount_percentage
        }, () => {
          this.setState({
              tripDiscount: this.props.discount.data.bookings[0].client_bookings[0].discount * this.props.discount.data.bookings[0].client_bookings.length,
              tripTotal: this.props.discount.data.bookings[0].client_bookings[0].price * this.props.discount.data.bookings[0].client_bookings.length + this.state.upgradePrice
          });
        });
      }

      //reset discount
      if(Object.keys(this.props.discount.data).length === 0 && !this.props.discount.valid){
        this.setState({discountPercent: 0});
      }


    }


  }

  renderDate(dates, duration){
    if(duration == null){
      return (dates === "") ? "No date selected" : dayjs(dates).format("Do MMMM YYYY");
    }else{
      return (duration === null || dates === "") ? "No date selected" : dayjs(dates).add(duration-1, 'days').format("Do MMMM YYYY");
    }
  }

  renderTime(time, dates){
    if(time !== undefined && dates !== "") return "at " + time.substring(0, time.lastIndexOf(":"));
  }

  renderLocation(location){
    if(location !== undefined) return "at " + location;
  }

  renderCity(locationArr, city){
    if(locationArr !== undefined){
        if(city === 'start' ){
          return ', ' + locationArr[0].name;
        }else{
          return', ' + locationArr[1].name;
        }
    }
  }

  renderExceptionMsg(dates, tourId){
    if(dates !== "" && tourId === "BOG"){
      return <span className="exception-txt"><br/>(End times vary depending on ferries. We strongly recommend booking onward travel for after 12pm the day following arrival back to Athens as the return ferry times can often vary and may be subject to delays.)</span>
    }
  }

  renderPaxDetail(paxType, currencySign){

    const _adultPrice = (this.state.adultPrice === 0 || this.state.adultNumber === 0) ? " " : currencySign + this.state.adultPrice + " x " + this.state.adultNumber + " =";
    const _adultTotalPrice = (this.state.adultPrice === 0) ? currencySign + "0.00" : " " + currencySign + this.state.adultPrice * this.state.adultNumber;

    if(paxType === 'adult' && this.props.currentBooking.departure_date !== "") return _adultPrice + _adultTotalPrice;

  }

  onContinueClick(){


    const {
      basketType,
      onContinue,
      SetProcessing,
      currency:{ iso_currency_code },
      FetchLiveCapacity,
      currentBooking:{tour_id, city_id, departure_date}
     } = this.props;


    //open depart modal - standalone
    if(basketType === "" || basketType ==="basket"){
        onContinue();
    }else{

      //Set processing preloader
      SetProcessing(true);


      //check live capacity
      FetchLiveCapacity(
        tour_id,
        iso_currency_code,
        city_id,
        dayjs(departure_date).format("YYYY"),
        dayjs(departure_date).format("MM"),
        dayjs(departure_date).format("DD")
      );

    }

  }

  render(){

    const {  tripDiscount, tripTotal, discountPercentText } = this.state;
    const { basketsummaryclass, currentBooking:{ departure_date, tour_id }, currency:{currency_mask}, product:{startTime, endTime, startDescription, endDescription, locations }, discount, productType, capacity, passengers, upgrades, upgradesLoading } = this.props;
    const currencySign = (currency_mask !== undefined) ? currency_mask.charAt(0) : "";
    const capacityDuration = (capacity.length !== 0 ) ? capacity.header.duration : "";

    return (
      <div className={`basketsummary ${basketsummaryclass}`}>

        <div className="summary-box">

          <div className="row title">
            <div className="column small-12">
              <h5 className="busabout-h5">Booking Summary</h5>
            </div>
          </div>

          <div className="row">

            <span style={{'display':(productType === 'hoho') ? 'none' : 'block'}}>

              <div className="column small-12">
                <p className="title"><span className="ba-icon ba_icon_departure_dates"></span>  Start</p>
                <p className="no-margin"> {this.renderDate(departure_date, null)} {this.renderTime(startTime, departure_date)}</p>
                <p className="location no-margin">{this.renderLocation(startDescription)}{this.renderCity(locations, 'start')}</p>
              </div>

              <hr />

              <div className="column small-12">
                <p className="title"><span className="ba-icon ba_icon_hoho"></span> End</p>
                <p className="no-margin"> {this.renderDate(departure_date, capacityDuration)} {this.renderTime(endTime, departure_date)}  {this.renderExceptionMsg(departure_date, tour_id)}</p>
                <p className="location no-margin">{this.renderLocation(endDescription)}{this.renderCity(locations, 'end')}</p>
              </div>

              <hr />

              <div className="column small-6">
                <p className="title no-margin">Duration </p>
              </div>

              <div className="column small-6">
                <p className="no-margin text-right"> {capacityDuration} Days</p>
              </div>

                <hr />

            </span>

            <div className="column small-12">
              <p className="title"><span className="ba-icon ba-icon-materates-alt"></span> Passengers </p>
            </div>

             <div className="column small-12 clearfix">
              <p className="no-margin">{this.state.adultNumber + ' Adults'}
                <span className="float-right">{this.renderPaxDetail('adult', currencySign)}</span>
              </p>

            </div>

            <div style={{ display:upgradesName(upgrades) === "" ? 'none': 'block' }}>
              <div className="column small-6">
                <p className="no-margin bold">{upgradesName(upgrades)}</p>
              </div>
              <div className="column small-6">
                <p className="no-margin bold float-right">{currencySign} { upgradesPrice(upgrades) * this.state.adultNumber }</p>
              </div>
            </div>

            <div className="column small-12" style={{display:(discount.valid) ? 'block' : 'none' }}>
              <p className="discount-text no-margin-bottom">{discountPercentText + "% Discount"}
                <span className="float-right">{`- ${currencySign}` + tripDiscount.toFixed(2) }</span>
              </p>
            </div>

            <div className="column small-12">
              <Promocode basketType={this.props.basketType} />
            </div>

          </div>


          <div className="row total-section" style={{display: (departure_date !== "") ? 'block':'none'}}>
            <div className="column small-6 bold">Total price</div>
            <div className="column small-6 text-right bold orange-text">{ `${currencySign}` + tripTotal.toFixed(2) }</div>
          </div>

        </div>

        <div className="row">
          <div className="column small-12">
            <button
              type="submit"
              className={`continue-btn busabout--cta orange ${(tour_id !== "" && departure_date !== "" && passengers.length > 0 && !upgradesLoading) ? '': 'disabled'}` }
              disabled={ (tour_id !== "" && departure_date !== "" && passengers.length > 0 && !upgradesLoading) ? false : true}
              onClick={this.onContinueClick}>
              Continue booking
            </button>
        </div>
       </div>

      </div>
    )
  }
}

function mapStateToProps(state){
  return{
    currency:state.currency,
    processing:state.currentBooking.processing,
    currentBooking:state.currentBooking.trips[0],
    discount:state.discount,
    prices:state.currentBooking.prices,
    passengers:state.currentBooking.passengers,
    product:state.product.content,
    productType:state.product.header.type,
    capacity:state.capacity.data,
    upgrades:state.upgrades.data,
    upgradesLoading:state.upgrades.isFetching
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchLiveCapacity,
    SetProcessing,
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(BasketSummary);



// WEBPACK FOOTER //
// ./src/components/basket/basketsummary.js